module.exports = __WEBPACK_EXTERNAL_MODULE_mggp_player__;